import { useSearchParams } from "react-router-dom";
import { ITabConfig } from "../../types/Config/ITabConfig";

export const useTabConfig = (): ITabConfig => {
    const [params] = useSearchParams();

    const parseNumberList = (key: string) => {
        const v = params.get(key);
        return v
            ? v
                .split(",")
                .map(s => parseInt(s.trim(), 10))
                .filter(n => !Number.isNaN(n) && n > 0)
            : [];
    };

    const parseStringList = (key: string) => {
        const v = params.get(key);
        return v ? v.split(",").map(s => s.trim()).filter(s => s.length > 0) : [];
    };

    return {
        tabName: params.get("tabName") || "Revelation Helpdesk",
        clientIds: parseNumberList("clientIds"),
        myCallsOnly: params.get("myCallsOnly") !== "0",
        projectIds: parseNumberList("projectIds"),
        statusIds: parseNumberList("statusIds"),
        prioritySetId: params.get("prioritySetId") ? parseInt(params.get("prioritySetId")!, 10) : undefined,
        priorityIds: parseNumberList("priorityIds"),
        queueIds: parseNumberList("queueIds"),
        teamIds: parseNumberList("teamIds"),
        states: parseStringList("states"),
        priorityNames: parseStringList("priorityNames"),
        statusNames: parseStringList("statusNames"),
        description: params.get("description") || "",
        revTenantId: params.get("revTenantId") || "",
        entityId: params.get("entityId") || "",
    } as ITabConfig;
};